import { useMutation, useQueryClient } from "@tanstack/react-query"
import axios from "axios"
import { getBackofficeReferralsQueryKey } from "modules/backoffice/lib/referrals/getBackofficeReferralsQuery"
import { getBackofficeOrganizationCreditsQueryKey } from "modules/backoffice/lib/organizations/getBackofficeOrganizationCreditsQuery"
import { getBackofficeOrganizationQueryKey } from "modules/backoffice/lib/organizations/getBackofficeOrganizationQuery"
import { getBackofficeOrganizationsQueryKey } from "modules/backoffice/lib/organizations/getBackofficeOrganizationsQuery"

type Props = {
  organizationId: string
  credits: number
  onSuccess?: () => void
}

export function useAddReferralCreditsMutation({ organizationId, credits, onSuccess }: Props) {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: async (referralLeadId: string) => {
      const response = await axios.post(`/backoffice/referrals/${referralLeadId}/credits`, {
        credits,
      })

      return response.data
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: getBackofficeReferralsQueryKey() })
      queryClient.invalidateQueries({
        queryKey: getBackofficeOrganizationQueryKey({ id: organizationId }),
      })
      queryClient.invalidateQueries({ queryKey: getBackofficeOrganizationsQueryKey() })
      queryClient.invalidateQueries({
        queryKey: getBackofficeOrganizationCreditsQueryKey(organizationId),
      })
      onSuccess?.()
    },
  })
}
